import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FacebookAuthPreviousState} from '../../app.constants';
import {AuthService} from '../../core/auth.service';

export enum FbAuthorisationError {
  MISSING_CODE = 'missing_code',
  INVALID_TOKEN = 'invalid_token',
  NO_BUSINESS_USER = 'no_business_user',
  ERROR_SELECT_USER = 'error_select_user',
  INVALID_INFLUENCER = 'invalid_influencer',
  UNABLE_TO_COLLECT_BACKWARD = 'unable_to_collect_backward',
  MISSING_PERMISSION = 'missing_permission',
  PAGE_SUBSCRIPTION_FAILED = 'page_subscription_failed',
  FACEBOOK_ERROR = 'facebook_error'
}

@Component({
  selector: 'fb-login-fail',
  templateUrl: './fb-login-fail.component.html',
  styleUrls: ['./fb-login-fail.component.scss']
})
export class FbLoginFailComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute,
              private router: Router,
              private auth: AuthService) { }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(res => {
      if (res.state) {
        const isAuthenticated = res.state.indexOf('authenticated') >= 0;
        if (isAuthenticated) {
          this.router.navigate(['dashboard', 'settings'], {
            queryParams: {
              error: res.error,
            }
          });
        } else if (res.state.indexOf(FacebookAuthPreviousState.ON_CAMPAIGN_INVITATION) >= 0) {
          const localAuthData = this.auth.getInfluencerChannelAuthorizationLocalData();
          return this.router.navigate(['dashboard', 'campaigns', localAuthData.campaignId, 'new'], {
            queryParams: {
              inviteToken: localAuthData.inviteToken,
              error: res.error,
            }
          });
        } else if (res.state.indexOf(FacebookAuthPreviousState.ON_CONTACT_PERMISSION) >= 0) {
          const localAuthData = this.auth.getInfluencerChannelAuthorizationLocalData();
          return this.router.navigate(['dashboard', 'contact-permission'], {
            queryParams: {
              error: res.error,
              accessToken: localAuthData.accessToken,
              permissionToken: localAuthData.permissionToken
            }
          });
        } else {
          this.router.navigate(['influencer', 'login'], {
            queryParams: {
              error: res.error,
            }
          });
        }
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/fb-testing-page/fb-login-fail/fb-login-fail.component.ts